import React from 'react'
//import ReactDOM from 'react-dom'
import Abm from './Abm'

function AboutMe () {
return (
  <Abm/>
)}

export default AboutMe;